const INITIAL_STATE = {
  agentes: {
    data: []
  },
  agente: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'AGENTES_FETCH':
      return { ...state, agentes: action.payload }
    case 'AGENTE_SET':
      return { ...state, agente: action.payload }
    case 'AGENTE_RESET':
      return { ...state, agente: null }
    default:
      return state
  }
}

